var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSheetAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.291,
    height: 20.291,
    viewBox: "0 0 20.291 20.291",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Notes",
    transform: "translate(20.291 20.291) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "New_Report",
    "data-name": "New Report",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52930",
    "data-name": "Path 52930",
    d: "M17.856,0H2.435A2.435,2.435,0,0,0,0,2.435V17.856a2.435,2.435,0,0,0,2.435,2.435H17.856a2.435,2.435,0,0,0,2.435-2.435V2.435A2.435,2.435,0,0,0,17.856,0Zm.812,17.856a.812.812,0,0,1-.812.812H2.435a.812.812,0,0,1-.812-.812V2.435a.812.812,0,0,1,.812-.812H17.856a.812.812,0,0,1,.812.812Z",
    fill: "#f45e29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52931",
    "data-name": "Path 52931",
    d: "M8.928,4.058H5.681V.812a.812.812,0,1,0-1.623,0V4.058H.812a.812.812,0,1,0,0,1.623H4.058V8.928a.812.812,0,1,0,1.623,0V5.681H8.928a.812.812,0,1,0,0-1.623Z",
    transform: "translate(5.276 5.276)",
    fill: "#f45e29"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSheetAdd);
export default __webpack_public_path__ + "static/media/icon-sheet-add.c7f081a4.svg";
export { ForwardRef as ReactComponent };